module.exports = __webpack_public_path__ + "img/gml_2_splash.3b14d887.jpg";